import HamburgerComponent from './hamburger.js';

export default HamburgerComponent;
